import { lightFormat, parse, subMonths } from 'date-fns';

export const mapDateRangeToObj = (date_range: string, withFuture = false) => {
  return {
    from_date: lightFormat(
      date_range === 'all'
        ? parse('2001-01-01', 'yyyy-MM-dd', new Date())
        : subMonths(new Date(), isNaN(+(date_range || '')) ? 120 : +(date_range || 12)),
      'yyyy-MM-dd',
    ),
    to_date: withFuture && date_range === 'all' ? undefined : lightFormat(new Date(), 'yyyy-MM-dd'),
  };
};
